/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IProdutosRepository } from "@/interface/produtos";

const produtosRepository: IProdutosRepository = {
  /**
   * Função para buscar fixas tecnicas
   * @param accessToken
   * @returns Promise<any | null>
   */
  async getAllProdutos<T>(
    accessToken: string,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem = "",
    somenteAtivos = false
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const ativoParam = somenteAtivos ? "&ativo=1" : "";
    const produtos = await Instance.get(
      `/products?page=${currentPage}&per_page=${itemsPerPage}&search=${searchItem}${ativoParam}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return produtos?.data;
  },
};

/**
 * EXPORTS
 */
export { produtosRepository };
